module.exports = __webpack_public_path__ + "h5/img/noRecords.5e055368.png";